<div class="container-fluid">
    <div class="row">

        <div class="card shadow-sm p-0">
            <div class="card-header">
                <h3 class="card-title">{{ pageTitle }}</h3>
            </div>
            <div class="card-body">
                <quality-document-group-form
                    [companyDocumentGroup]="companyDocumentGroup"
                    (onSavedData)="onSavedData($event)" />
            </div>
        </div>
    </div>
</div>
